import HeaderCom from '@/components/Header';
import {bizURL} from "@/config/baseUrl";
import ApplyForm from '@/components/applyForm';
import pdf from 'vue-pdf';

export default {
    name: 'home',
    components: {
        HeaderCom,
        ApplyForm,
        pdf
    },
    data() {
        return {
            id: 0,
            closeNotice: false,//关闭消息提示框，配合批次弹框，关闭之后不在弹出
            total: 0, // 总条目数
            currentPage: 1, // 当前页
            limit: 10, // 每页显示数量
            loading: false,
            isCurrent: 0,
            tabValue: 'name1',
            printModal: false,
            pdfUrl: '', // 打印报名表地址
            isPhoto: true, // 显示上传
            isFront: true, // 显示上传
            isBack: true, // 显示上传
            isBook: true, // 显示上传
            isRegistion: true, // 显示上传
            isDisabled: false, // 禁止表单修改
            payNum: '', // 支付状态
            // isPay: false, // 缴费按钮禁用
            // isInfo: false, // 禁止资料修改
            nameDisabled: true, // 姓名禁用
            genderDisabled: true, // 性别禁用
            cardDisabled: true, // 身份证号禁用
            telDisabled: true, // 手机号禁用
            currentStatusTag: '', //审核状态(显示)
            currentStatus: '', // 审核状态
            workflowStatus: '', // 当前状态
            currentState: '', // 当前状态
            status: '',
            curStatus: '',
            currentStatusComment: '', // 审核意见
            genderList: [],
            degreeList: [], // 学历
            specialList: [], // 测试专业名称
            levelList: [], // 测试专业级别
            jobList: [], // 现任专业职务
            titleList: [], // 现任专业职务级别
            fileData: {},
            frontData: [], // 身份证人像面
            backData: [], // 身份证国徽面
            bookData: [], // 职称证书
            registionData: [], // 盖章报名表
            ticket: {}, // 打印准考证
            isPlan: false,
            certificateObj: {}, // 证书
            uploadUrl: bizURL + "/registration/registration/upload",
            uploadData: {Authorization: sessionStorage.getItem("token")},
            addApplyForm: {
                photo: '',
                name: '',
                gender: '男',
                idNumber: '',
                tel: '',
                highestDegree: '',
                graduationDate: '',
                workingYears: '',
                major: '',
                majorWorkYears: '',
                majorJob: '',
                majorJobTitle: '',
                jobDate: '',
                unitName: '',
                archivesUnit: '',
                postCode: '',
                examMajor: '',
                examMajorTitle: '',
                address: ''
            },
            addApplyRule: {
                photo: [{required: true, message: '本人证件照为必传', trigger: 'change'}],
                name: [{required: true, message: '姓名为必填', trigger: 'change'}],
                idNumber: [
                    {required: true, message: '身份证号为必填', trigger: 'change'},
                    {pattern: /(^\d{15}$)|(^\d{17}([0-9]|x|X)$)/, message: "证件号码格式有误！", trigger: "change"}
                ],
                tel: [
                    {required: true, message: '联系电话为必填', trigger: 'change'},
                    {pattern: /^1\d{10}$/, message: "手机号格式不对", trigger: "blur"}
                ],
                highestDegree: [{required: true, message: '最高学历为必填', trigger: 'change'}],
                graduationDate: [{required: true, message: '毕业时间为必填', trigger: 'change'}],
                workingYears: [
                    {required: true, message: '工作年限为必填', trigger: 'change'},
                    {pattern: /^[a-z0-9]+$/, message: '请输入数字', trigger: 'change'}
                ],
                major: [{required: true, message: '所学专业为必填', trigger: 'change'}],
                majorWorkYears: [
                    {required: true, message: '专业工作年限为必填', trigger: 'change'},
                    {pattern: /^[a-z0-9]+$/, message: '请输入数字', trigger: 'change'}
                ],
                majorJob: [{required: true, message: '现任专业职务为必填', trigger: 'change'}],
                majorJobTitle: [{required: true, message: '现任专业职务级别为必填', trigger: 'change'}],
                jobDate: [{required: true, message: '任现职时间为必填', trigger: 'change'}],
                unitName: [{required: true, message: '工作单位为必填', trigger: 'change'}],
                archivesUnit: [{required: true, message: '存档单位为必填', trigger: 'change'}],
                postCode: [{required: true, message: '邮政编码为必填', trigger: 'change'}],
                examMajor: [{required: true, message: '测试专业名称为必填', trigger: 'change'}],
                examMajorTitle: [{required: true, message: '测试级别为必填', trigger: 'change'}],
                address: [{required: true, message: '通讯地址为必填', trigger: 'change'}]
            },
            infoForm: {
                idcardHead: '', //身份证头像面
                idcardNationalEmblem: '', //身份证国徽面
                registion: '', //盖章报名表
                titleCertificate: '', //职称证书表
            },
            infoRule: {
                idcardHead: [{required: true, message: '身份证头像面为必传', trigger: 'change'}],
                idcardNationalEmblem: [{required: true, message: '身份证国徽面为必传', trigger: 'change'}],
                titleCertificate: [{required: true, message: '职称证书表为必传', trigger: 'change'}],
                registion: [{required: true, message: '报名表为必传', trigger: 'change'}]
            },
            auditForm: {
                photo: '',
                name: '',
                gender: '男',
                idNumber: '',
                tel: '',
                highestDegree: '',
                graduationDate: '',
                workingYears: '',
                major: '',
                majorWorkYears: '',
                majorJob: '',
                majorJobTitle: '',
                jobDate: '',
                unitName: '',
                archivesUnit: '',
                postCode: '',
                examMajor: '',
                examMajorTitle: '',
                address: '',
                idcardHead: '', //身份证头像面
                idcardNationalEmblem: '', //身份证国徽面
                registion: '', //盖章报名表
                titleCertificate: '', //职称证书表
            },
            passForm: {
                result: '通过',
                comment: '同意',
                name: '管理员',
                time: '2020-09-09',
                passFlag: true
            },
            passRule: {},
            tabColumns: [
                {title: '序号', type: 'index', width: 50, align: 'center'},
                {title: '操作人', key: 'createBy', align: 'center'},
                {title: '操作时间', key: 'createTime', align: 'center'},
                {
                    title: '状态', key: 'workFlowName', align: 'center',
                    render: (h, params) => {
                        let tmpStr = params.row.workFlowName;
                        return h('span', {
                            style: {
                                color: (params.row.workflowStatus == 150) ? "#ed3f14" : (params.row.workflowStatus == 200 ? "#19be6b" : "#2d8cf0")
                            }
                        }, tmpStr)
                    }
                },
                {title: '审核意见', key: 'comment', align: 'center'}
            ],
            tabData: [],
            payData: {},
            payColumns: [
                {title: '表头', key: 'head', align: 'center', width: 200},
                {title: '内容', key: 'comment', align: 'center'}
            ],
            payDatas: [
                {head: '姓名', comment: '张三'},
                {head: '性别', comment: '女'},
                {head: '身份证号', comment: '420116199912043765'},
                {head: '联系电话', comment: 'ZJ202008260001'},
                {head: '测试专业名称', comment: '水利水电工程专业（系列）'},
                {head: '测试级别', comment: '中级'},
                {head: '缴费状态', comment: '已缴费'},
                {head: '缴费时间', comment: '2020-08-20 15:30'},
                {head: '平台订单号', comment: '2342342'},
                {head: '支付宝订单号', comment: '23424234'},
            ],
            scoreColumns: [
                {title: '表头', key: 'head', align: 'center', width: 200},
                {title: '内容', key: 'comment', align: 'center'}
            ],
            scoreData: [
                {head: '姓名', comment: '张三'},
                {head: '性别', comment: '女'},
                {head: '身份证号', comment: '420116199912043765'},
                {head: '准考证号', comment: 'ZJ202008260001'},
                {head: '工作单位', comment: '单位'},
                {head: '测试专业名称/考试科目', comment: '水利水电工程专业（系列）'},
                {head: '考试时间', comment: '2020-08-20 15:30'},
                {head: '考试地点', comment: '地点'},
                {head: '考称号', comment: '20'},
                {head: '考试结果', comment: '合格/不合格'},
                {head: '考试结果说明', comment: '本次考试的分数为50分，考试不合格'},
            ],
            printColumn: [
                {title: '2020年湖北省水利电力工程专业技术职务水平能力测试准考证', key: 'head', align: 'center'}
            ],
            printData: [
                // { head: '姓名', comment: '张三' },
                // { head: '性别', comment: '女' },
                // { head: '身份证号', comment: '420116199912043765' },
                // { head: '准考证号', comment: 'ZJ202008260001' },
                // { head: '工作单位', comment: '单位' },
                // { head: '测试专业名称/考试科目', comment: '水利水电工程专业（系列）' },
                // { head: '考试时间', comment: '2020-08-20 15:30' },
                // { head: '考试地点', comment: '地点' },
                // { head: '考称号', comment: '20' },
                // { head: '考试结果', comment: '合格/不合格' },
                // { head: '考试结果说明', comment: '本次考试的分数为50分，考试不合格' },
            ],
            addApplyModal: false, // 提交审核弹框
            finishTime: {
                shortcuts: [
                    {
                        text: "今天",
                        value() {
                            return new Date();
                        },
                    },
                    {
                        text: "昨天",
                        value() {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            return date;
                        },
                    },
                    {
                        text: "一周前",
                        value() {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            return date;
                        },
                    },
                ]
            },
            batch: {}
        }
    },
    computed: {
        enableRegister() {
            return this.batch && Date.parse(this.batch.registerTimeBegin) < Date.parse(new Date()) && Date.parse(new Date()) < Date.parse(this.batch.registerTimeEnd)
        },
        enablePrintCertificate() {
            return this.batch && Date.parse(this.batch.printCertificateDateBegin) < Date.parse(new Date()) && Date.parse(new Date()) < Date.parse(this.batch.printCertificateDateEnd)
        }
    },

    mounted() {
        // this.showNotice();
        this.biz_gender();
        this.biz_degree();
        this.biz_job();
        this.biz_title();
        this.biz_exam_speciality();
        this.biz_exam_speciality_level();
        this.getMyLast();
    },
    methods: {
        // showNotice() {
        //     this.$Modal.info({
        //         title: "温馨提示",
        //         content: "<p>成绩查询及合格证书打印时间：2022年8月15日17:00至2022年9月15日下午17:00。</p>"
        //     })
        // },
        showNotice(batch) {
            if (batch && batch.showNotice == 1 && this.closeNotice == false) {
                this.$Modal.info({
                    title: "温馨提示",
                    content: batch.noticeContent,
                    onOk: () => {
                        this.closeNotice = true;
                    }
                })
            }
        },

        // 性别
        biz_gender() {
            this.$comHttp.biz_gender().then(data => {
                if (data.code == '200') {
                    this.genderList = data.data;
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {
                this.$Message.error(error);
            })
        },
        // 学历
        biz_degree() {
            this.$comHttp.biz_degree().then(data => {
                if (data.code == '200') {
                    this.degreeList = data.data;
                    sessionStorage.setItem('degreeList', JSON.stringify(data.data));
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {
                this.$Message.error(error);
            })
        },
        // 测试专业名称
        biz_exam_speciality() {
            this.$comHttp.biz_exam_speciality().then(data => {
                if (data.code == '200') {
                    this.specialList = data.data;
                    sessionStorage.setItem('specialList', JSON.stringify(data.data));
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {
                this.$Message.error(error);
            })
        },
        // 测试专业级别
        biz_exam_speciality_level() {
            this.$comHttp.biz_exam_speciality_level().then(data => {
                if (data.code == '200') {
                    this.levelList = data.data;
                    sessionStorage.setItem('levelList', JSON.stringify(data.data));
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {
                this.$Message.error(error);
            })
        },
        // 现任专业职务
        biz_job() {
            this.$comHttp.biz_job().then(data => {
                if (data.code == '200') {
                    this.jobList = data.data;
                    sessionStorage.setItem('jobList', JSON.stringify(data.data));
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {
                this.$Message.error(error);
            })
        },
        // 现任专业职务级别
        biz_title() {
            this.$comHttp.biz_title().then(data => {
                if (data.code == '200') {
                    this.titleList = data.data;
                    sessionStorage.setItem('titleList', JSON.stringify(data.data));
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {
                this.$Message.error(error);
            })
        },
        // 切换步骤状态
        tabChange(val) {
            switch (val) {
                case 'name1':
                    this.isCurrent = 0;
                    this.$refs["addApplyForm"].resetFields();
                    this.getMyLast();
                    break;
                case 'name2':
                    this.isCurrent = 1;
                    break;
                case 'name3':
                    this.isCurrent = 2;
                    if (this.currentStatus != 0 && this.pay == 0) {
                        this.isCurrent = 2;
                        val = 'name3';
                    }
                    if (this.currentStatus == 200 && this.pay == 1) {
                        this.isCurrent = 3;
                        val = 'name4';
                    }
                    this.getMyLast();
                    this.commentList();
                    break;
                case 'name4':
                    this.isCurrent = 3;
                    this.getMyLast();
                    break;
                case 'name5':
                    this.isCurrent = 4;
                    this.examTicket();
                    break;
                case 'name6':
                    this.isCurrent = 5;
                    this.getResult();
                    break;
                default:
                    break;
            }
            this.tabValue = val;
        },
        getCheckTag(checked, submit) {
            var checkTag = "";
            if (checked == 1) {
                checkTag = "审核通过";
            } else if (checked == 2) {
                checkTag = "审核不通过";
            } else if (submit == 1) {
                checkTag = "待审核";
            } else if (submit == 0) {
                checkTag = "填报";
            } else {
                checkTag = "未知状态";
            }
            return checkTag;
        },
        // 获取我的报名信息
        getMyLast() {
            this.$http.getMyLast().then(data => {
                if (data.code == '200') {
                    // sessionStorage.setItem('userInfo', JSON.stringify(data.data));
                    var data = data.data;
                    this.batch = data.batch;
                    this.showNotice(data.batch);
                    this.id = data.id;
                    this.currentStatus = data.currentStatus;
                    this.status = data.currentStatus;
                    this.curStatus = this.getCheckTag(data.checked, data.submit);
                    this.status == null ? 0 : this.currentStatus;
                    this.currentStatusTag = data.currentStatusTag;
                    this.currentStatusTag == null ? '12' : this.currentStatusTag;
                    if (this.status == 0 || this.status == 150) { // 0: 填报  150: 待审核
                        this.isPhoto = true;
                        this.isFront = true;
                        this.isBack = true;
                        this.isBook = true;
                        this.isRegistion = true;
                    } else {
                        this.isPhoto = false;
                        this.isFront = false;
                        this.isBack = false;
                        this.isBook = false;
                        this.isRegistion = false;
                    }

                    this.pay = data.regPay;
                    this.payNum = data.regPay == null ? '0' : data.regPay;
                    // this.pay == 0 ? (this.isPay = false) : (this.isPay = true);
                    data.currentStatus = data.currentStatus == null ? 0 : data.currentStatus;
                    this.examMajorTitle = data.examMajorTitle;
                    this.currentStatus = (data.currentStatus == '0' || data.currentStatus == '150') ? this.isDisabled = false : this.isDisabled = true;
                    if (data.id == null || data.id == 0) {
                        this.fileData.url = data.photo; //登记照
                        this.addApplyForm.photo = data.photo; //登记照
                        this.addApplyForm.name = data.name;
                        this.addApplyForm.gender = data.gender;
                        this.addApplyForm.idNumber = data.idNumber;
                        this.addApplyForm.tel = data.tel;
                    } else {
                        this.fileData.url = data.photo; //登记照
                        this.addApplyForm.photo = data.photo; //登记照
                        this.addApplyForm.name = data.name;
                        this.addApplyForm.gender = data.gender;
                        this.addApplyForm.idNumber = data.idNumber;
                        this.addApplyForm.tel = data.tel;
                        this.addApplyForm.highestDegree = data.highestDegree;
                        this.addApplyForm.graduationDate = data.graduationDate;
                        this.addApplyForm.workingYears = data.workingYears;
                        this.addApplyForm.major = data.major;
                        this.addApplyForm.majorJobTitle = data.majorJobTitle;
                        this.addApplyForm.majorWorkYears = data.majorWorkYears;
                        this.addApplyForm.majorJob = data.majorJob;
                        this.addApplyForm.majorJobTitle = data.majorJobTitle;
                        this.addApplyForm.jobDate = data.jobDate;
                        this.addApplyForm.unitName = data.unitName;
                        this.addApplyForm.archivesUnit = data.archivesUnit;
                        this.addApplyForm.postCode = data.postCode;
                        this.addApplyForm.examMajor = data.examMajor;
                        this.addApplyForm.examMajorTitle = data.examMajorTitle;
                        this.addApplyForm.address = data.address;
                        this.infoForm.idcardHead = data.idcardHead; //身份证头像面
                        this.frontData = [];
                        this.frontData.push({url: data.idcardHead});
                        this.infoForm.idcardNationalEmblem = data.idcardNationalEmblem; //身份证国徽面
                        this.backData = [];
                        this.backData.push({url: data.idcardNationalEmblem});
                        this.infoForm.titleCertificate = data.titleCertificate; //职称证书表
                        this.bookData = [];
                        this.bookData.push({url: data.titleCertificate});
                        this.infoForm.registion = data.registion; //盖章报名表
                        this.registionData = [];
                        this.registionData.push({url: data.registion});
                        this.currentStatusTag = data.currentStatusTag; // 审核状态
                        this.currentStatusComment = data.currentStatusComment // 审核意见
                    }
                    if (data.currentStatus >= 100) {
                        this.getLastByRegId();
                    }
                    // if (this.pay == 1) {
                    //   this.isCurrent = 3;
                    //   this.tabValue = 'name4';
                    // }
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {

            })
        },
        // 打印报名表
        saveAndPrint(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.printModal = true;
                    this.print(this.id);
                } else {
                    return false;
                }
            })
        },
        // 打印
        print() {
            this.$http.print({
                // id: this.id,
                photo: this.addApplyForm.photo, //登记照
                name: this.addApplyForm.name,
                gender: this.addApplyForm.gender,
                idNumber: this.addApplyForm.idNumber,
                tel: this.addApplyForm.tel,
                highestDegree: this.addApplyForm.highestDegree,
                graduationDate: this.addApplyForm.graduationDate,
                workingYears: this.addApplyForm.workingYears,
                major: this.addApplyForm.major,
                majorWorkYears: this.addApplyForm.majorWorkYears,
                majorJob: this.addApplyForm.majorJob,
                majorJobTitle: this.addApplyForm.majorJobTitle,
                jobDate: this.addApplyForm.jobDate,
                unitName: this.addApplyForm.unitName,
                archivesUnit: this.addApplyForm.archivesUnit,
                postCode: this.addApplyForm.postCode,
                examMajor: this.addApplyForm.examMajor,
                examMajorTitle: this.addApplyForm.examMajorTitle,
                address: this.addApplyForm.address
            }).then(data => {
                if (data.code == '200') {
                    // this.isPhoto = false;
                    // this.$http.download(data.msg);
                    this.pdfUrl = `${bizURL}/common/download?fileName=${data.msg}&delete=false`;
                    this.printModal = true;
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {

            })
        },

        // deleteApply() {
        //     this.$Modal.confirm({
        //         title: '确认删除吗',
        //         content: '<p>这将删除之前填报的记录及上传的材料，确认删除吗?</p>',
        //         onOk: () => {
        //             let params = {"id": this.id}
        //             this.$http.deleteApply(params).then(data => {
        //                 if (data.code == '200') {
        //                     this.$Message.success("删除成功!");
        //                     window.location.reload();
        //                 } else {
        //                     this.$Message.error(data.msg);
        //                 }
        //             }).catch(error => {
        //                 this.$Message.error(error);
        //             })
        //         },
        //         onCancel: () => {
        //             console.log("取消删除")
        //         }
        //     });
        //
        //
        // },
        reApply() {
            this.$Modal.confirm({
                title: '确认重新报名吗',
                content: '<p>这将重新开始报名流程，确认重新报名吗?</p>',
                onOk: () => {
                    this.id = 0;
                    this.currentStatus = 0;
                    this.save();
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);

                },
                onCancel: () => {
                    console.log("取消重新报名")
                }
            });


        },
        // 填写报名表(保存)
        saveApply(name) {
            // this.$refs[name].validate((valid) => {
            // if (valid) {
            let success = this.save();
            console.log('21212', success)
            if (success == false) {
                this.$Message.success('信息已保存成功！');
            }
            // } else {
            //   return false;
            // }
            // })
        },
        // 填写报名表(下一步)
        saveNext(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$Message.success('报名表信息已保存!');
                    this.save();
                    setTimeout(() => {
                        this.tabValue = 'name2';
                    }, 500)
                } else {
                    return false;
                }
            })
        },
        // 保存报名表
        async save() {
            let result = true;
            var params = {
                id: this.id,
                photo: this.addApplyForm.photo, //登记照
                name: this.addApplyForm.name,
                gender: this.addApplyForm.gender,
                idNumber: this.addApplyForm.idNumber,
                tel: this.addApplyForm.tel,
                highestDegree: this.addApplyForm.highestDegree,
                graduationDate: this.addApplyForm.graduationDate,
                workingYears: this.addApplyForm.workingYears,
                major: this.addApplyForm.major,
                majorWorkYears: this.addApplyForm.majorWorkYears,
                majorJob: this.addApplyForm.majorJob,
                majorJobTitle: this.addApplyForm.majorJobTitle,
                jobDate: this.addApplyForm.jobDate,
                unitName: this.addApplyForm.unitName,
                archivesUnit: this.addApplyForm.archivesUnit,
                postCode: this.addApplyForm.postCode,
                examMajor: this.addApplyForm.examMajor,
                examMajorTitle: this.addApplyForm.examMajorTitle,
                address: this.addApplyForm.address
            }
            if (this.currentStatus == '0' || this.currentStatus == '150' || this.currentStatus == null) {
                await this.$http.save(params).then(data => {
                    if (data.code == '200') {
                        // this.isPhoto = true;
                        this.id = data.data;
                    } else {
                        result = false;
                        this.$Message.error(data.msg);
                    }
                }).catch(error => {
                    this.$Message.error(error);
                    result = false;
                })
            } else {
                this.isDisabled = false;
                // this.$Message.success('123');
                // this.isCurrent = 1;
                // this.tabValue = 'name2';
            }
            return result;
        },
        saveInfo() {
            var params = {
                id: this.id,
                idcardHead: this.infoForm.idcardHead, //身份证头像面
                idcardNationalEmblem: this.infoForm.idcardNationalEmblem, //身份证国徽面
                titleCertificate: this.infoForm.titleCertificate, //职称证书表
                registion: this.infoForm.registion, //盖章报名表
            }
            this.$http.save(params).then(data => {
                if (data.code == '200') {
                    this.id = data.data;
                    this.$Message.success("提交审核成功!");
                    this.auditInfo();
                    // setTimeout(()=>{
                    //   this.isCurrent = 2;
                    //   this.tabValue = 'name3';
                    //   this.commentList();
                    // },500)
                } else {
                    this.$Message.error(data.msg);
                }
            })
        },
        // 提交审核
        saveAudit() {
            var applyForm = false;
            this.$refs['addApplyForm'].validate((valid) => {
                applyForm = valid;
            })
            var infoForm = false;
            this.$refs['infoForm'].validate((valid) => {
                infoForm = valid;
            })
            if (!applyForm) {
                this.$Message.warning('报名表信息填写不完整,请先完善!');
                return false;
            }
            if (!infoForm) {
                this.$Message.warning('资料上传不完整,请先完善!');
                return false;
            }
            this.$Modal.confirm({
                title: "确定要提交审核吗?",
                onOk: () => {
                    this.saveInfo();
                    // this.auditInfo();
                },
                cancelText: "取消",
            });
        },
        // 提交审核(弹框数据回显)
        visibleChange(val) {
            if (val == true) {
                for (var key in this.addApplyForm) {
                    // console.log(key, this.addApplyForm[key]);
                    this.auditForm[key] = this.addApplyForm[key];
                }
                for (var key in this.infoForm) {
                    this.auditForm[key] = this.infoForm[key];
                }
            }
        },
        // 提交审核
        auditInfo() {
            var idList = [];
            idList.push(this.id);
            this.$http.auditInfo({
                regIdList: idList
            }).then(data => {
                if (data.code == '200') {
                    this.tabValue = 'name3';
                    this.getMyLast();
                    this.commentList();
                    this.isPhoto = false;
                    this.isFront = false;
                    this.isBack = false;
                    this.isBook = false;
                    this.isRegistion = false;
                    this.addApplyModal = false;
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {

            })
        },
        // 页码改变的回调，返回改变后的页码(当前页)
        sizeChange(val) {
            this.currentPage = val;
            this.commentList();
        },
        // 切换每页条数时的回调，返回切换后的每页条数(每页数)
        pageChange(val) {
            console.log(val, 'meiyeshu')
            this.limit = val;
            this.commentList();
        },
        // 查看审核意见
        commentList() {
            var params = {
                regId: this.id,
                pageNum: this.currentPage,
                pageSize: this.limit
            }
            this.$http.commentList(params).then(data => {
                if (data.code == '200') {
                    this.tabData = data.rows;
                    data.rows.forEach(item => {
                        this.workflowStatus = item.workflowStatus;
                        this.currentState = item.workFlowName;
                    })
                    this.total = data.total;
                    this.isCurrent = 2;
                    this.tabValue = 'name3';
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {
                this.$Message.error(error);
            })
        },
        // 缴费
        payBtn() {
            this.isCurrent = 3;
            this.tabValue = 'name4';
            // let routeUrl = this.$router.resolve({
            //     path: '/apply',
            //     query: {
            //         id: this.id,
            //         examMajorTitle: this.examMajorTitle
            //     }
            // });
            this.$router.push({
                path: '/apply',
                query: {
                    id: this.id,
                    examMajorTitle: this.examMajorTitle
                }
            });
            // window.open(routeUrl.href, '_blank');
        },
        // 缴费列表
        getLastByRegId() {
            this.$http.getLastByRegId({
                regId: this.id
            }).then(data => {
                if (data.code == '200') {
                    this.payData = data.data;
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {

            })
        },
        // 获取准考证信息
        examTicket() {
            // this.isPlan = true;
            this.$http.examTicket(this.id).then(data => {
                if (data.code == '200') {
                    // this.isPlan = false;
                    this.ticket = data.data;
                } else {
                    // this.$Message.error(data.msg);
                }
            }).catch(error => {
                this.$Message.error(error);
            })
        },
        // 打印准考证
        printExamTicket() {
            this.$http.printExamTicket(this.id).then(data => {
                if (data.code == '200') {
                    this.$http.download(data.msg);
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {
                this.$Message.error(error);
            })
        },
        // 获取证书信息
        getResult() {
            if(!this.id){
                this.$Message.error("暂无考试成绩!");     
                return;   
            }
            this.$http.getResult(this.id).then(data => {
                if (data.code == '200') {
                    this.certificateObj = data.data;
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {

            })
        },
        // 打印证书
        printBtn() {
            this.$http.printCertificate(this.id).then(data => {
                if (data.code == '200') {
                    this.$http.download(data.msg);
                } else {
                    this.$Message.error(data.msg);
                }
            }).catch(error => {
                this.$Message.error(error);
            })
        },
        finishChange(val) {
            this.addApplyForm.graduationDate = val;
        },
        jobDateChange(val) {
            this.addApplyForm.jobDate = val;
        },
        // 本人登记照
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$Message.warning({
                    background: true,
                    content: "上传图片大小不能超过 2MB！"
                });
            }
            return isLt2M;
        },
        handleSuccess(res, file) {
            this.fileData = file;
            file.url = res.fileName;
            file.name = res.fileName;
            this.addApplyForm.photo = res.fileName;
            // this.$refs.photo.clearFiles(); // 清空头像
        },

        // 身份证人像面
        frontUpload(file) {
            this.frontData = [];
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$Message.warning({
                    background: true,
                    content: "上传图片大小不能超过 2MB！"
                });
            }
            return isLt2M;
        },
        frontSuccess(res, file) {
            this.frontData.push(file);
            file.url = res.fileName;
            file.name = res.fileName;
            this.infoForm.idcardHead = res.fileName;
            // this.$refs.photo.clearFiles(); // 清空头像
        },
        // 身份证国徽面
        backUpload(file) {
            this.backData = [];
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$Message.warning({
                    background: true,
                    content: "上传图片大小不能超过 2MB！"
                });
            }
            return isLt2M;
        },
        backSuccess(res, file) {
            // this.backData = file;
            this.backData.push(file);
            file.url = res.fileName;
            file.name = res.fileName;
            this.infoForm.idcardNationalEmblem = res.fileName;
            // this.$refs.photo.clearFiles(); // 清空头像
        },
        // 职称证书
        bookUpload(file) {
            this.bookData = [];
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$Message.warning({
                    background: true,
                    content: "上传图片大小不能超过 2MB！"
                });
            }
            return isLt2M;
        },
        bookSuccess(res, file) {
            this.bookData.push(file);
            file.url = res.fileName;
            file.name = res.fileName;
            this.infoForm.titleCertificate = res.fileName;
            // this.$refs.photo.clearFiles(); // 清空头像
        },
        // 盖章报名表
        registionUpload(file) {
            this.registionData = [];
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$Message.warning({
                    background: true,
                    content: "上传图片大小不能超过 2MB！"
                });
            }
            return isLt2M;
        },
        registionSuccess(res, file) {
            this.registionData.push(file);
            file.url = res.fileName;
            file.name = res.fileName;
            this.infoForm.registion = res.fileName;
            // this.$refs.photo.clearFiles(); // 清空头像
        },
        addNext(name) {
            this.tabValue = name;
            this.isCurrent = name.substring(name.length - 1, name.length) * 1 - 1;
            this.getMyLast();
        },
        // 合并单元格
        handleSpan({row, column, rowIndex, columnIndex}) {
            console.log(rowIndex, 'rowIndex');
            console.log(columnIndex, 'columnIndex');
            if (rowIndex === 0 && columnIndex === 0) {
                return [1, 2];
            } else if (rowIndex === 0 && columnIndex === 1) {
                return [0, 0];
            }
            if (rowIndex === 2 && columnIndex === 0) {
                return {
                    rowspan: 2,
                    colspan: 1
                };
            } else if (rowIndex === 3 && columnIndex === 0) {
                return {
                    rowspan: 0,
                    colspan: 0
                };
            }
        }
    }
}